import R from 'ramda'

const SEND_EMAIL_ACTION_TYPE = 'SEND_EMAIL'
const SEND_EMAIL_DISPLAY_TYPE = 'Send email'

const isSendEmailWidgetAction = R.propEq('type', SEND_EMAIL_ACTION_TYPE)

const getDisplayType = R.always(SEND_EMAIL_DISPLAY_TYPE)
const getAddress = R.path(['recipients', 'to'])
const getSubject = R.prop('subject')
const getMessage = R.prop('body')

const convertSendEmailWidgetActionToFormAction = R.applySpec({
  type: getDisplayType,
  address: getAddress,
  subject: getSubject,
  message: getMessage
})

export { isSendEmailWidgetAction, convertSendEmailWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/send-email.js